import { accountingSettingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ACCOUNTING_SETTING_ACTION_TYPE = createNamedActions('accountingSetting', {
  GET_SETTINGS: 'GET_SETTINGS',
  EDIT_SETTING: 'EDIT_SETTING',
});

export const getAccountingSettingsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await accountingSettingApi.getSettings();

  return dispatch({
    type: ACCOUNTING_SETTING_ACTION_TYPE.GET_SETTINGS,
    payload: data,
  });
});

export const editAccountingSettingsAction = catchAsyncActionError(
  ({ companyId, ...body }) =>
    async dispatch => {
      const { data } = await accountingSettingApi.editSetting({ body, companyId });

      return dispatch({
        type: ACCOUNTING_SETTING_ACTION_TYPE.EDIT_SETTING,
        payload: data,
      });
    },
);
